import { render } from "./MainInfo.vue?vue&type=template&id=9536963a&scoped=true"
import script from "@/assets/js/Home/MainInfo.js?vue&type=script&lang=js&external"
export * from "@/assets/js/Home/MainInfo.js?vue&type=script&lang=js&external"

import "./MainInfo.vue?vue&type=style&index=0&id=9536963a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9536963a"]])

export default __exports__